import { WEB_ONBOARDING_COMPLETED_STORAGE_KEY } from '../../ui-foundation/features/onboarding';

function hasWindowStorage() {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
}

export function loadWebOnboardingCompleted() {
  if (!hasWindowStorage()) {
    return false;
  }

  return window.localStorage.getItem(WEB_ONBOARDING_COMPLETED_STORAGE_KEY) === 'true';
}

export function saveWebOnboardingCompleted() {
  if (!hasWindowStorage()) {
    return;
  }

  window.localStorage.setItem(WEB_ONBOARDING_COMPLETED_STORAGE_KEY, 'true');
}

export function clearWebOnboardingCompleted() {
  if (!hasWindowStorage()) {
    return;
  }

  window.localStorage.removeItem(WEB_ONBOARDING_COMPLETED_STORAGE_KEY);
}
